import { render, staticRenderFns } from "./custom-title.vue?vue&type=template&id=1c7a0242&scoped=true&"
import script from "./custom-title.vue?vue&type=script&lang=js&"
export * from "./custom-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a0242",
  null
  
)

export default component.exports